import * as Yup from 'yup'

const addressSchema = Yup.object({
	_id: Yup.string().optional(),
	fullname: Yup.string().required('El nombre completo es requerido'),
	document_type: Yup.string().required('El tipo de documento es requerido'),
	document: Yup.number()
		.required('El documento es requerido')
		.positive('El documento debe ser un número positivo'),
	province: Yup.string().required('La provincia es requerida'),
	city: Yup.string().required('La ciudad es requerida'),
	neighborhood: Yup.string().required('El barrio es requerido'),
	street_type: Yup.string().required('El tipo de calle es requerido'),
	street: Yup.string().required('La calle es requerida'),
	number_home: Yup.string().required('El número de casa es requerido'),
	type_home: Yup.string().required('El tipo de hogar es requerido'),
	phone: Yup.number()
		.required('El teléfono es requerido')
		.test('len-range', 'El teléfono debe tener entre 6 y 15 dígitos', (val) => {
			if (!val) return false
			const len = val.toString().length
			return len >= 6 && len <= 15
		}),
	postal_code: Yup.string()
		.required('El código postal es requerido')
		.matches(/^\d{6}$/, 'El código postal debe tener 6 dígitos'),
	additional_references: Yup.string().optional(),
})

export const createCustomerSchema = Yup.object({
	_id: Yup.string().optional(),
	role: Yup.string().oneOf(['customer']).optional(),
	name: Yup.string().required('El nombre es requerido'),
	lastname: Yup.string().required('El apellido es requerido'),
	email: Yup.string()
		.email('Debe ser un email válido')
		.required('El email es requerido'),
	phone: Yup.number()
		.required('El teléfono es requerido')
		.positive('El teléfono debe ser un número positivo')
		.test('len', 'El teléfono debe tener 10 dígitos', (val) =>
			val ? val.toString().length === 10 : false
		),
	code: Yup.number()
		.optional()
		.positive('El código debe ser un número positivo'),
	password: Yup.string()
		.required('La contraseña es requerida')
		.min(6, 'La contraseña debe tener al menos 6 caracteres'),
	confirmPassword: Yup.string()
		.required('Confirmar contraseña es requerido')
		.oneOf([Yup.ref('password')], 'Las contraseñas deben coincidir'),
	address: Yup.array(addressSchema).optional(),
	_created: Yup.date().optional(),
})


export interface UserUpdateFormData {
	name: string
	lastname: string
}

export const userUpdateSchema = Yup.object({
	name: Yup
		.string()
		.required('El nombre es requerido')
		.min(2, 'El nombre debe tener al menos 2 caracteres')
		.max(50, 'El nombre no puede exceder 50 caracteres')
		.matches(/^[a-zA-ZáéíóúÁÉÍÓÚñÑ\s]+$/, 'El nombre solo puede contener letras'),
	lastname: Yup
		.string()
		.required('El apellido es requerido')
		.min(2, 'El apellido debe tener al menos 2 caracteres')
		.max(50, 'El apellido no puede exceder 50 caracteres')
		.matches(/^[a-zA-ZáéíóúÁÉÍÓÚñÑ\s]+$/, 'El apellido solo puede contener letras')
})

